import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.requestPasswordReset(email);
      setSent(true);
    } catch (error) {
      // Always show success message for security (don't reveal if email exists)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_game-tracker-92/artifacts/62gbiyum_WhatsApp%20Image%202026-01-30%20at%2002.16.12.jpeg" 
              alt="Kahve LİGİ Logo"
              className="w-28 h-28 rounded-2xl object-contain"
            />
            <span className="text-3xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider gold-gradient-text">
              Kahve LİGİ
            </span>
          </Link>
        </div>

        <div className="glass-card p-6">
          {!sent ? (
            <>
              <h2 className="text-xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider text-white text-center mb-2">
                Şifremi Unuttum
              </h2>
              <p className="text-sm text-[#B1C1C1] text-center mb-6">
                E-posta adresini gir, şifre sıfırlama bağlantısı gönderelim.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="email" className="text-[#B1C1C1]">E-posta Adresi</Label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="ornek@email.com"
                      className="pl-10 bg-[#050E2E]/50 border-white/10 text-white h-11"
                      required
                      data-testid="email-input"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  disabled={loading || !email}
                  className="w-full bg-[#4DFFFF] text-[#050E2E] hover:bg-[#4DFFFF]/90 font-['Barlow_Condensed'] uppercase tracking-wider font-bold h-11"
                  data-testid="submit-btn"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Gönderiliyor...
                    </>
                  ) : (
                    "Şifre Sıfırlama Bağlantısı Gönder"
                  )}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4">
              <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-green-400" />
              </div>
              <h2 className="text-xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider text-white mb-2">
                E-posta Gönderildi
              </h2>
              <p className="text-sm text-[#B1C1C1] mb-6">
                Eğer bu e-posta adresiyle kayıtlı bir hesabın varsa, şifre sıfırlama bağlantısı e-posta adresine gönderildi.
              </p>
              <p className="text-xs text-[#64748B] mb-4">
                Bağlantı 30 dakika içinde geçerliliğini yitirecektir.
              </p>
            </div>
          )}

          <Link 
            to="/login" 
            className="flex items-center justify-center gap-2 text-sm text-[#4DFFFF] hover:underline mt-4"
          >
            <ArrowLeft className="w-4 h-4" />
            Giriş sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
}
